// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const importPrivateListsUrl = "api/ksc/importPrivateLists";

export interface ImportPrivateListsModal {
    message: string;
    importedListsCount: number;
}

export async function getPrivateListsService(): Promise<ServiceResult<ImportPrivateListsModal>> {
    try {
        const result = await post<ImportPrivateListsModal>(importPrivateListsUrl);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
